import Vue from 'vue'
import Router from 'vue-router'
// import Brower from '@/utils/Brower'
import { getToken, removeToken } from '@/utils/auth'
import store from "@/store";
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('../views/layout/index.vue'),
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import('../views/homePage/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('../views/about/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/blog',
          name: 'blog',
          component: () => import('../views/blog/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/detail',
          name: 'detail',
          component: () => import('../views/blog/detail.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/contact',
          name: 'contact',
          component: () => import('../views/contact/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/privacy',
          name: 'privacy',
          component: () => import('../views/privacy/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/partner',
          name: 'partner',
          component: () => import('../views/partner/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { y: 0 }
  }
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

router.beforeEach(async (to, from, next) => {
  //next();
  let token = getToken()
  let username = store.state.username
  if (token) {
    if (!username) {
      try {
        await store.dispatch("getUserInfo")
        next()
      } catch (error) {
        removeToken()
        next("/login")
      }
    }
    if (to.path == "/login") {
      next("/")
    }
  } else {
    let toPath = to.path.toLowerCase();
    if (toPath.indexOf("/user") != -1) {
      next("/login?redirect=" + toPath)
    }
    //next()
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js